<tidy-card>
  <tidy-row class="vertical-align-center brand-section">
    <tidy-image
      [src]="'assets/img/star.svg'"
      class="title-size" />
    <tidy-text
      [header]="'Preferred Brands'" />
  </tidy-row>
  <tidy-row class="extra-bottom-padding">
    <tidy-text
      [helper]="'Ranked brand waterfall: first choice on top, then backups. We order the first choice that\'s available, then fall back down the list.'" />
  </tidy-row>

  @if (items.length === 0) {
    <tidy-row [align]="'center'" class="extra-bottom-padding">
      <tidy-text
        [helper]="'No preferred brands yet — add your first choice below.'" />
    </tidy-row>
  }

  @if (items.length > 0) {
    <tidy-drag-drop
      dragDropId="brand-waterfall"
      [dataList]="items"
      [disabled]="disabled"
      emptyListMessage="No preferred brands yet"
      (listDropped)="onReorder($event)">
      @for (brand of items; track brand; let index = $index) {
        <ng-container *tidyDragDropItem>
          <tidy-row [alignLastItemRight]="true" class="vertical-align-center" [class.extra-top-padding]="index > 0">
            @if (!disabled) {
              <tidy-image
                [src]="'assets/svg/reorder-four-outline.svg'"
                class="body-size waterfall-drag" />
            }
            <div class="brand-rank" [class.brand-rank-first]="index === 0">{{ index + 1 }}</div>
            <tidy-text
              [body]="index === 0 ? 'First choice' : 'Backup ' + index"
              [translate]="false"
              class="bold" />
            @if (!disabled) {
              <div
                class="brand-remove-icon"
                (click)="removeBrand(index)"></div>
            }
          </tidy-row>
          <tidy-row>
            <tidy-input
              [icon]="'assets/svg/pricetag.svg'"
              [label]="'Name'"
              [placeholder]="'e.g. Charmin'"
              [(ngModel)]="brand.brand"
              (ngModelChange)="onFieldChange()" />
          </tidy-row>
          @if (showTierErrors(brand) && brandNameInvalid(brand)) {
            <tidy-row>
              <tidy-error-message
                [text]="'Name is required'" />
            </tidy-row>
          }
          <tidy-row>
            <tidy-input
              [icon]="'assets/svg/cube.svg'"
              [label]="'# Units per pack'"
              [placeholder]="'e.g. 12'"
              [type]="'number'"
              [inputMode]="'numeric'"
              [ngModel]="brand.amount"
              (ngModelChange)="onAmountChange(brand, $event)" />
          </tidy-row>
          @if (showTierErrors(brand) && amountInvalid(brand)) {
            <tidy-row>
              <tidy-error-message
                [text]="'Enter the number of units per pack'" />
            </tidy-row>
          }
          <tidy-row>
            <tidy-input
              [icon]="'assets/svg/link.svg'"
              [label]="'Walmart Business product link'"
              [placeholder]="walmartPrefix + ('ip/...' | translate)"
              [(ngModel)]="brand.link"
              (ngModelChange)="onFieldChange()"
              (blur)="onLinkBlur(brand)" />
          </tidy-row>
          @if (linkFormatInvalid(brand)) {
            <tidy-row>
              <tidy-error-message
                [text]="('Link must begin with ' | translate) + walmartPrefix" />
            </tidy-row>
          } @else if (showTierErrors(brand) && linkMissing(brand)) {
            <tidy-row>
              <tidy-error-message
                [text]="'Walmart link is required'" />
            </tidy-row>
          }
          <!--
            Model / product (brand.product_name) and Notes (brand.notes) are still
            part of the model but hidden from the editor to match the concierge
            product-defaults waterfall. Un-hide these rows to re-enable them.
          -->
        </ng-container>
      }
    </tidy-drag-drop>
  }

  @if (!disabled) {
    <tidy-row [align]="'center'" class="extra-top-padding">
      <tidy-text
        class="link brand-add-link"
        [body]="items.length === 0 ? '+ Add a preferred brand' : '+ Add another brand'"
        (action)="addBrand()" />
    </tidy-row>
  }
</tidy-card>
